<script lang="ts">
export default {
  name: "MainFobizzNavbarMyFobizzMenuLink",
};
</script>

<script setup lang="ts">
import BaseIcon from "@/components/Base/Icon/index.vue";
import { type Props as BaseIconProps } from "@/components/Base/Icon/index.vue";
import { RouteNamedMap } from "vue-router/auto-routes";

export type Props = BaseIconProps & {
  title?: string;
  routeTo?: keyof RouteNamedMap;
  renderAsLink?: boolean;
  href?: string;
  iconName?: BaseIconProps["iconName"];
  iconSvg?: BaseIconProps["iconSvg"];
};

const props = withDefaults(defineProps<Props>(), {
  title: undefined,
  iconName: undefined,
  iconSvg: undefined,
  routeTo: undefined,
  renderAsLink: false,
  href: undefined,
});

const component = computed(() => {
  if (props.renderAsLink && props.href) {
    return "a";
  } else {
    return "router-link";
  }
});

const toOrHref = computed(() => {
  if (props.renderAsLink && props.href) {
    return { href: props.href };
  } else if (!props.renderAsLink && !!props.routeTo) {
    return { to: { name: props.routeTo } };
  }
  return false;
});
</script>

<template>
  <component
    :is="component"
    v-if="toOrHref"
    class="my-fobizz-offcanvas__menu__link-item"
    v-bind="{ ...$attrs, ...toOrHref }"
  >
    <slot>
      <BaseIcon
        v-if="iconName || iconSvg"
        :icon-name="iconName"
        :icon-svg="iconSvg"
      />
      {{ title }}
    </slot>
  </component>

  <span v-if="!toOrHref">Missing Link</span>
</template>
